import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Flow from './components/Flow';
import WatchPage from './components/WatchPage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"                     element={<Flow />} />
        <Route path="/title/:id"            element={<Flow />} />
        <Route path="/where-to-watch/:slug" element={<WatchPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
